module.exports = __webpack_public_path__ + "static/media/Owners-Club-Logo.f32473d5.png";